import React from "react";
import { ModalDialog } from "@culturehq/components";
import { useModal } from "app/context/ModalContext";

const ChqModalDialog = ({ children, style = {}, ...props }) => {
  const { registerModal } = useModal() || {};
  const rootRef = document.getElementById("root");

  return (
    <ModalDialog {...props} style={{ ...style, overlay: { backgroundColor: "rgba(0, 0, 0, 0.7", ...style.overlay } }} appElement={rootRef} registerModal={registerModal}>
      {children}
    </ModalDialog>
  );
};

export default ChqModalDialog;
